import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class SubsysteminforApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'subsysteminfor'
    }
    /**
     * 查询子系统列表
     * @param subSystemName 
     */
    public getSubsystemList(subSystemName){
        return this.send({subSystemName:subSystemName},"getSubsystemList",Methods.GET)
    }

    /**
     * 保存或修改子系统
     * @param params 
     */
    public saveSubsystem(params){
        return this.send(params,"update",Methods.POST)
    }
    /**
     * 删除子系统
     * @param ids 
     */
    public deleteSubsystem(ids){
        return this.send({},"delete?ids="+ids,Methods.POST)
    }

    /**
     * 根据项目id获取子系统
     * @param subSystemName
     */
    public getListByProjectId(projectId){
        return this.send({projectId:projectId},"getListByProjectId",Methods.GET)
    }

    /**
     * 根据子项目id获取子系统
     * @param projectId
     */
    public getListByParam(subProjectId,institutionRootId){
        return this.send({subProjectId:subProjectId,institutionRootId:institutionRootId},"getListByParam",Methods.GET)
    }

    /**
     * 根据用户id获取子系统角色信息
     * @param usreId
     */
    public getSystemByUserId(userId, institutionRootId, institutionId){
        return this.send({userId:userId, institutionRootId: institutionRootId, institutionId: institutionId},"getSystemByUserId",Methods.GET)
    }

}